import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className ="bg-black text-white py-8 mt-auto">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="flex flex-col columns-3 lg:flex-row justify-between items-center gap-6 sm:gap-8">
          {/* Social Media Section */}
          <div className="w-full sm:w-auto text-center sm:text-left">
            <p className="text-sm mb-4">Follow us for the latest update</p>
            <div className="flex justify-center sm:justify-start gap-4">
              {/* <a 
                href="https://facebook.com" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="hover:text-[#CDA454] transition-colors"
              >
                <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"/>
                </svg>
              </a> */}
              <a 
                href="https://www.linkedin.com/company/jurident/" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="hover:text-[#CDA454] transition-colors"
              >
                <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M19 3a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h14m-.5 15.5v-5.3a3.26 3.26 0 00-3.26-3.26c-.85 0-1.84.52-2.32 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4a1.4 1.4 0 011.4 1.4v4.93h2.79M6.88 8.56a1.68 1.68 0 001.68-1.68c0-.93-.75-1.69-1.68-1.69a1.69 1.69 0 00-1.69 1.69c0 .93.76 1.68 1.69 1.68m1.39 9.94v-8.37H5.5v8.37h2.77z"/>
                </svg>
              </a>
              <a 
                href="https://www.instagram.com/jurident.legal" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="hover:text-[#CDA454] transition-colors"
              >
                <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
              </a>
            </div>
          </div>
          
          {/* Links Section */}
          <div className="w-full sm:w-auto">
            <div className="flex flex-col sm:flex-row items-center sm:items-start gap-4 sm:gap-8">
              <Link to="/portal/faq" className="text-sm hover:text-[#CDA454] transition-colors">FAQ</Link>
              <Link to="/portal/terms" className="text-sm hover:text-[#CDA454] transition-colors">Terms and conditions</Link>
              <Link to="/portal/refunds" className="text-sm hover:text-[#CDA454] transition-colors">Refunds and cancellation</Link>
              <Link to="/portal/contactus" className="text-sm hover:text-[#CDA454] transition-colors">Contact Us</Link>
              <Link to="/portal/feedback" className="text-sm hover:text-[#CDA454] transition-colors">Feedback</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer; 